import React, { useState, useEffect } from 'react'
import { Banner } from '../Banner'
import { Pengumuman } from '../Pengumuman'
// import { Oss } from './Oss'
import { Investasi } from './Investasi'
import { Procurement } from './Procurement'
import { CsrCatalog } from './CsrCatalog'
// import { Silat } from './Silat'
import { Bighug } from './Bighug'
// import { Promosi } from './Promosi'
import { Skm } from './Skm'
import { Terhubung } from './Terhubung'

function Beranda() {
    const [showStats, setShowStats] = useState(false)

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div className="container">
                <Banner />
                <Pengumuman />
            </div>
            {/* <Oss /> */}
            <CsrCatalog showStats={showStats}/>
            <Bighug setShowStats={setShowStats}/>
            <Investasi />
            <Procurement />
            {/* <Silat /> */}
            <Skm />
            {/* <Promosi /> */}
            <Terhubung />
        </>
    )
}

export default Beranda